import { useQuery } from "@tanstack/react-query";

import { useAppState } from "../context/StateContext";
import { Searches, Filters } from "../models/shipeezi.table";
import ProductService from "../services/product.service";
import { ProductKeys } from "../util/queries";

export type ProductQueryOptions = {
  minimalList?: boolean;
  endpointVersion?: "v1" | "v2";
};

const useActionProduct = () => {
  const { currentUser } = useAppState();

  const getAllProducts = (
    page: number,
    pageSize: number,
    searches?: Searches,
    filters?: Filters,
    include?: any[],
    options?: ProductQueryOptions
  ) => {
    return useQuery({
      enabled: !!currentUser?.companyId,
      queryFn: async () => {
        const requestData = {
          page,
          pageSize,
          companyId: currentUser?.companyId,
          sortBy: JSON.stringify([["updatedAt", "DESC"]]),
          searchByOr: searches && searches.length > 0 ? JSON.stringify(searches) : "",
          ...filters,
          ...(options?.minimalList ? { minimalList: true } : {}),
        };
        const response =
          options?.endpointVersion === "v2"
            ? await ProductService.getAllV2(requestData)
            : await ProductService.getAll({
                ...requestData,
                include: include ? JSON.stringify(include) : "",
              });
        const products = response?.data || [];

        return products;
      },
      queryKey: ProductKeys.getAllProducts([
        page,
        pageSize,
        searches,
        filters,
        include,
        options?.minimalList,
        options?.endpointVersion,
      ]),
    });
  };

  const countProducts = (
    page: number,
    pageSize: number,
    searches?: Searches,
    filters?: Filters,
    include?: any[],
    options?: ProductQueryOptions
  ) => {
    return useQuery({
      enabled: !!currentUser?.companyId,
      queryFn: async () => {
        const requestData = {
          companyId: currentUser?.companyId,
          searchByOr: searches && searches.length > 0 ? JSON.stringify(searches) : "",
          ...filters,
          ...(options?.minimalList ? { minimalList: true } : {}),
        };
        const response =
          options?.endpointVersion === "v2"
            ? await ProductService.countV2(requestData)
            : await ProductService.count({
                ...requestData,
                include: include ? JSON.stringify(include) : "",
              });
        const total = response?.data || 0;

        return total;
      },
      queryKey: ProductKeys.count([
        searches,
        filters,
        include,
        options?.minimalList,
        options?.endpointVersion,
      ]),
    });
  };

  return {
    getAllProducts,
    countProducts,
  };
};

export default useActionProduct;
